import type { Answers, BriefingMeta, MetaFieldMap } from "../types";

function textAnswer(answers: Answers, id: string): string {
  const value = answers[id];
  return typeof value === "string" ? value : "";
}

/**
 * The four meta fields are already questions inside section 01 of every
 * briefing — deriving them from answers avoids tracking the same values in two
 * places with two sources of truth. Which ids they live under differs per
 * questionnaire, hence the map.
 */
export function deriveMeta(answers: Answers, map: MetaFieldMap): BriefingMeta {
  return {
    company: textAnswer(answers, map.company),
    reportName: textAnswer(answers, map.reportName),
    contactName: textAnswer(answers, map.contactName),
    contactEmail: textAnswer(answers, map.contactEmail),
  };
}
